module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Medium.e63313c2.woff";